// BL
import { FinancialAccountReconciliationWithTransactions } from '@/reducers/admin/allFinancialAccountReconciliationsReducer'
import {
  ShallowTransaction,
  Transaction,
} from '@/reducers/admin/allTransactions.slice'
import { TransactionCollection } from './shared'
import { formatCurrencyFromCents } from '@/utils/currencyHelpers'

/**
 * Combines two sets of transactions into one.
 * Reco.transactions wins in the event of conflicting ids
 *
 * Returns a sorted array (date DESC) of TransactionModel[]
 */
export function generateTableDatasource(
  reconciliation: FinancialAccountReconciliationWithTransactions,
  transactions: (Transaction | ShallowTransaction)[]
) {
  const result: TransactionCollection = {}

  function populate(t: Transaction | ShallowTransaction, matched: boolean) {
    const formattedDollars = formatCurrencyFromCents(t.amountInCents)
    result[t.id] = {
      id: t.id,
      reconciliationId: reconciliation.id,
      date: t.date,
      description: t.description,
      manualUpload: Boolean(t.manuallyCreated),
      debit: t.amountInCents < 0 ? formattedDollars : null,
      credit: t.amountInCents >= 0 ? formattedDollars : null,
      matched,
    }
  }

  reconciliation.transactions?.forEach((t: Transaction | ShallowTransaction) =>
    populate(t, true)
  )

  transactions.forEach((t: Transaction | ShallowTransaction) => {
    if (!result[t.id]) {
      populate(t, false)
    }
  })

  const datasource = Object.values(result)
  datasource.sort((a, b) => (new Date(a.date) < new Date(b.date) ? 1 : -1))

  return datasource
}
